import {Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirmdialog.component.html',
  styleUrls: ['./confirmdialog.component.scss']
})
export class ConfirmDialogComponent implements AfterViewInit {

  @ViewChild('message') messageParagraph: ElementRef | undefined;

  title: string;
  public message: string;
  okOnly: boolean;
  confirmText: string;
  dismissText: string;
  cancelText?: string;
  confirmDisabled: boolean;

  constructor(
      public dialogRef: MatDialogRef<ConfirmDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel
  ) {
    this.title = data.title;
    this.message = data.message;
    this.okOnly = data.okOnly;
    this.confirmText = data.confirmText || (this.okOnly ? 'OK' : 'Yes');
    this.dismissText = data.dismissText || 'No';
    this.cancelText = data.cancelText;
    this.confirmDisabled = !!data.confirmDisabled;
  }

  update(): void {
    this.ngAfterViewInit();
  }

  ngAfterViewInit(): void {
    // @ts-ignore
    this.messageParagraph.nativeElement.innerHTML = this.message;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}

export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
    public okOnly = false,
    public confirmText?: string,
    public dismissText?: string,
    public confirmDisabled = false,
    public cancelText?: string,
  ) {
  }

}
